import initSlickWithArrowEvent from "../components/slick-utils";

function initMaierSectionShopMediaSlick() {
    let slick = initSlickWithArrowEvent(
        $('.maier-section-shop-media'),
        {
            dots: true,
            arrows: false,
            dotsClass: 'maier-section-shop-media-dots',
            autoplay: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        }
    );

    slick.on('afterChange', function(event, slick, currentSlide) {
        var activeDotEl = $(event.target).find('.maier-section-shop-media').find('li.slick-active');
        if (activeDotEl.get(0)) {
            activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    });
}

document.addEventListener('DOMContentLoaded', initMaierSectionShopMediaSlick);